import m from "../../geodata/es2015/guineaHigh";
window.am4geodata_guineaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/guineaHigh.js
// module id = null
// module chunks = 